<template>
  <el-row>
    <el-card v-for="(item,index) in zabbix_alarm_data"
             v-model="zabbix_alarm_tableData" :key="index"
             @click.native="card_click(item)"

             style=""
             :class="{'import-color-background':item.alert_level == '3','danger-color-background':item.alert_level == '4','disaster-color-background':item.alert_level == '5'}"
             class="box-card zbx-trigger-card alert-rule-item " :body-style="cart_body_style">
      <div class="text">
        <div style="float: left;margin-bottom: 4px;">
          <div style="float: left;height: 100%;width:30px" :class="twinkle_computer(item.alert_time,item.is_confirm)">

            <span v-if="item.alert_level == '5'">
              <img :src="disaster" class="disaster_img">
            </span>
            <span v-else-if="item.alert_level == '4'">
              <img :src="heart_break" class="heart_break_img">
            </span>
            <span v-else-if="item.alert_level == '3'">
              <img :src="heart" class="important_img">
              <!--              <i class="el-icon-omnis-hongxin important_text icon_text"></i>-->
            </span>
            <span v-else-if="item.alert_level == '2'">

              <i class="el-icon-omnis-hongxin warning_text icon_text"></i>

            </span>
            <span v-else-if="item.alert_level == '1'">
              <i class="el-icon-omnis-hongxin remind_text icon_text"></i>
            </span>
            <span v-else>
              <i class="el-icon-omnis-hongxin unknown_text icon_text"></i>
            </span>
          </div>
          <div style="float: left">
            <div style="margin-bottom: 0.1rem">
                <span style="margin: 0px;font-weight: bold">
                  <span class="text_title" :title="item.alert_msg">{{item.alert_msg}}</span>
                  <span class="text_title" :title="item.alert_msg" style="margin-left: 10px;">{{item.hostip}}</span>
                  <span class="text_title" style="color: #888984;font-weight: 400">
                    <template>
                    <span
                      style="color: #444444"
                      v-if="item.server_busi_name==null||item.server_busi_name==undefined">  {{item.hostname}}</span>
                    <span v-else> {{item.server_busi_name}}</span>
                  </template>
                </span>
                  <span class="text_title" :title="item.alert_msg" style="margin-left: 10px;">{{item.project}}</span>

                </span>
            </div>
            <div>


               <span style="margin: 0px" :class="twinkle_computer(item.alert_time,item.is_confirm)">
                      <span class="problem_text">PROBLEM</span>
                      <template>

                          <span v-if="item.alert_level == '-1'" style="background-color: #EDF7F0;color: #b0b4cf"
                                align="center">
                            未知
                          </span>
                          <span v-if="item.alert_level == '0'" style="background-color: #B7DBAB;color: white"
                                align="center">
                                      信息
                          </span>
                        <span v-if="item.alert_level == '1'" class="remind_text"
                              align="center">
                                提醒
                        </span>
                        <span v-if="item.alert_level == '2'" class="warning_text "
                              align="center">
                                警告
                        </span>
                        <span v-if="item.alert_level == '3'" class="important_text"
                              align="center">
                              重要
                        </span>
                        <span v-if="item.alert_level == '4'" class="high_text"
                              align="center">
                              严重
                        </span>
                        <span v-if="item.alert_level == '5'" class="disaster_text"
                              align="center">
                          危险
                        </span>
                      </template>

                    </span>
              <span style="color: #888984;font-weight: 400">
                {{item.alert_time}}
              </span>
              &nbsp&nbsp
              <span style="color: #888984;font-weight: 400">for {{$_time_formatter_spacing(item.alert_time)}}</span>
            </div>
          </div>

        </div>


        <div style="width: 240px;float: right;padding-top: 7px">


          <span>

            <i class="el-icon-success button_text" style="color: rgb(111,169,199);font-size: 24px" title="确认告警"
               @click="confirm_warn_button"></i>

             <i class="el-icon-odometer button_text" title="监控大盘" style="color: rgb(51,75,92);font-size: 23px"
                @click="big_panel_button(item.hostip,item.project)"></i>
            <!--               <i>-->
            <!--                <template>-->
            <!--                  <span v-if="item.is_recover=='1'">-->
            <!--                     <i class="el-icon-omnis-xiaolian" title="恢复状态：已恢复"-->
            <!--                        style="color: #66CC00;font-size: 16px;"></i>-->
            <!--                  </span>-->
            <!--                  <span v-else-if="item.is_recover=='0'">-->
            <!--                     <i class="el-icon-omnis-kulian" title="恢复状态：未恢复"-->
            <!--                        style="color: #238ff9;font-size: 16px;"></i>-->
            <!--                  </span>-->
            <!--                  <span v-else></span>-->
            <!--                </template>-->
            <!--              </i>-->
            <!--                     <i class="el-icon-omnis-weiwangguanicon-defuben-" title="预警状态：关闭"-->
            <!--                        style="color: grey;font-size: 16px;"></i>-->
            <!--                  </span>-->
            <!--                  <span v-else></span>-->
            <!--                </template>-->
            <!--            </i>-->


            <i class="el-icon-s-opportunity button_text" style="color: #E6A23C;font-size: 22px" title="AI智能分析"
               @click.stop="ai_analysis_button(item)"></i>
            <i class="el-icon-omnis-jiankongleixing-xiugai button_text" style="color: rgb(59,176,201);font-size: 22px" title="历史记录"
               @click="history_list_button(item)"></i>
            <!--             <i class="el-icon-omnis-mqxiaoxiduilieMQ button_text" style="color: rgb(62,177,91)"  title="消息队列"-->
            <!--                @click="information_list_button(item)" v-show="message_button_dia"></i>-->

             <i @click="information_list_button(item)" class="el-icon-omnis-xiaoxi1" style="font-size: 24px;color:rgb(62,177,91);">
                  <span

                    style=" display: inline-block;vertical-align: top;font-size: 20px;transform: translateY(6px)"
                    title="信息数量">
                          <span

                            style="font-size:12px;display:  inline-block;color:rgb(62,177,91);height: 15px; line-height: 15px;text-align: center"
                          > {{item.msg_count}}</span>
                    </span>
           </i>
               <i class="el-icon-omnis-neirongxitong button_text" title="信息" style="color: rgb(122,185,218);font-size: 20px"
                  @click="infor_mon_button"></i>


          </span>
        </div>
      </div>
    </el-card>

    <el-dialog
      title="信息查看"
      v-loading="scan_add_loading"
      :visible.sync="dialog_information_panel"
      width="500px"
      :close-on-click-modal="false">
      <el-form style="padding: 5px" :label-position="labelPosition" labelWidth="90px" size="mini"
               class="form_information">
        <el-form-item label="IP:" style="padding-left: 0px;">
          <span>
          {{click_warning.hostip}}
          </span>
        </el-form-item>
        <!--        <el-form-item label="监控分组:" style="padding-left: 0px;">-->
        <!--          <span>-->
        <!--          {{click_warning.monitor_agent_group}}-->
        <!--          </span>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="探针:" style="padding-left: 0px;">-->
        <!--    <span>-->
        <!--    {{click_warning.monitor_agent_id}}-->
        <!--    </span>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="服务:" style="padding-left: 0px;">-->
        <!--    <span>-->
        <!--    &lt;!&ndash;{{click_warning}}&ndash;&gt;-->
        <!--    </span>-->
        <!--        </el-form-item>-->
        <el-form-item label="问题:" style="padding-left: 0px;">
    <span>
    {{click_warning.alert_msg}}
    </span>
        </el-form-item>
        <!--        <el-form-item label="确认状态:" style="padding-left: 0px;">-->
        <!--            <span v-if="click_warning.is_confirm==1">-->
        <!--            已确认-->
        <!--            </span>-->
        <!--          <span v-if="click_warning.is_confirm==0">-->
        <!--            未确认-->
        <!--            </span>-->
        <!--          <span v-if="click_warning.is_confirm==2">-->
        <!--            关闭-->
        <!--            </span>-->
        <!--          <span v-else></span>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="确认消息：" style="padding-left: 0px;">-->
        <!--            <span>-->
        <!--            {{click_warning.confirm_message}}-->
        <!--            </span>-->
        <!--        </el-form-item>-->
        <el-form-item label="解决方案：" style="padding-left: 0px;">
    <span>
    {{click_warning.alertitem_solution}}
    </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialog_information_panel = false">关 闭</el-button>
  </span>
    </el-dialog>

    <el-dialog
      title="告警确认"
      v-loading="scan_add_loading"
      :visible.sync="dialog_warning_confirm"
      width="550px"
      :close-on-click-modal="false">

      <el-form style="padding: 4px" :label-position="labelPosition" size="mini" :model="confirm_alarm"
               class="form_information">
        <div style="margin-bottom: 15px">
          <span
            style="font-size: 13px;">  {{click_warning.hostip}}&nbsp&nbsp{{click_warning.hostname}}&nbsp&nbsp{{click_warning.alertitem_code}}</span><br>
          <span style="margin-top: 3px">{{click_warning.alertitem_desc}}</span>
        </div>
        <el-form-item label="确认信息" style="padding-left: 0px;">
          <el-input v-model="confirm_alarm.confirm_message" style="width: 80%;" autocomplete="off" size="mini"
                    type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item>
          <template>
            <!-- `checked` 为 true 或 false -->
            <el-checkbox v-model="confirm_alarm.is_close" size="mini" true-label="1" false-label="0">
              <span style="font-size: 13px">关闭问题</span></el-checkbox>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialog_warning_confirm = false">关 闭</el-button>
           <el-button size="mini" @click="confirm_alarm_button()">确认</el-button>
  </span>
    </el-dialog>

    <!--历史信息查看-->
    <el-dialog
      title="历史信息查看"

      :visible.sync="dialog_history_panel"
      width="90%"
      :close-on-click-modal="false">
      <div style="overflow: auto" id="infor_div">
        <el-table
          class="el-table-filter"
          highlight-current-row
          :data="infor_list_tableData"
          size="mini"
          v-loading="scan_add_loading"
        >
          <el-table-column
            label="级别"
            width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.alert_level == '-1'"
                   style="background-color: #EDF7F0;color: #0f0f0f;font-weight: bold"
                   align="center">
                未知
              </div>
              <div v-if="scope.row.alert_level == '0'" style="background-color: #B7DBAB;color: white"
                   align="center">
                信息
              </div>
              <div v-if="scope.row.alert_level == '1'" style="background-color: #82B5D8;color: white" align="center">
                提醒
              </div>
              <div v-if="scope.row.alert_level == '2'" style="background-color: #E5AC0E;color: white" align="center">
                警告
              </div>
              <div v-if="scope.row.alert_level == '3'" style="background-color: #C15C17;color: white"
                   align="center">
                重要
              </div>
              <div v-if="scope.row.alert_level == '4'" style="background-color: #BF1B00 ;color: white"
                   align="center">
                严重
              </div>
              <div v-if="scope.row.alert_level == '5'" style="background-color: #890F02;color: white" align="center">
                危险
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="alert_time"
            label="告警时间"
            width="150"
            sortable
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column
            prop="recover_time"
            label="恢复时间"
            width="150"
            sortable
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column
            prop="server_busi_name"
            label="资源名称"
            width="250"
            show-overflow-tooltip
            sortable>
            <template slot-scope="scope">
              <label v-if="scope.row.server_busi_name">
                {{scope.row.server_busi_name}}
              </label>
              <label v-else>
                {{scope.row.hostname}}
              </label>

            </template>

          </el-table-column>
          <el-table-column
            prop="server_ip"
            label="主机"
            width="150"
            show-overflow-tooltip
            sortable>
            <template slot-scope="scope">
              <label v-if="scope.row.server_ip">
                {{scope.row.server_ip}}
              </label>
              <label v-else>
                {{scope.row.hostip}}
              </label>
            </template>
          </el-table-column>

          <el-table-column
            prop="alertitem_code"
            label="告警编码"
            width="100"
            sortable>
          </el-table-column>

          <el-table-column
            prop="alert_msg"
            label="问题"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column
            prop="is_confirm"
            label="是否恢复"
            width="70"
          >
            <template slot-scope="scope">
               <span v-if="scope.row.is_recover=='0'">
                    <i class="el-icon-circle-close" title="未恢复"
                       style="color: #E6A23C;font-size: 19px;font-weight: bold"></i>
                  </span>
              <span v-if="scope.row.is_recover=='1'">
                 <i class="el-icon-circle-check" title="已恢复"
                    style="color: #66CC00;font-size: 19px;font-weight: bold"></i>
              </span>
              <!--              <span v-if="scope.row.is_recover=='2'">-->
              <!--                 <i class="el-icon-circle-check" title="关闭"-->
              <!--                    style="color: red;font-size: 19px;font-weight: bold"></i>-->
              <!--              </span>-->
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column
            label="消息"
            prop="msg_count"
            width="50"
            show-overflow-tooltip>
            <template slot-scope="scope">
  <span
    style="border-radius: 50%;height: 15px;width: 15px; display: inline-block;vertical-align: top;border: 1px solid #238ff9">
      <span
        style="display: block;color: #238ff9;height: 15px; line-height: 15px;text-align: center"> {{scope.row.msg_count}}</span>
 </span>
            </template>
          </el-table-column>
          <el-table-column
            label="其他信息"
            width="100"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-omnis-neirongxitong" size="mini" title="查看信息"
                         @click="infor_mon_button2(scope.row)"></el-button>
            </template>
          </el-table-column>
          <!--          npm-->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <span style="float: left">显示最近15天的信息</span>
    <el-button size="mini" @click="dialog_history_panel = false">关 闭</el-button>
  </span>
    </el-dialog>

    <!--消息队列查看-->
    <el-dialog
      title="消息队列查看"
      v-loading="scan_add_loading"
      :visible.sync="dialog_inforlist_panel"
      width="500px"
      :close-on-click-modal="false">

      <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialog_inforlist_panel = false">关 闭</el-button>
  </span>
    </el-dialog>


    <el-dialog

      class="dish"
      :visible.sync="dish_show"
      width="95%"
      top="2vh"
      title="监控大盘"

    >
      <monitor_big_dish ref="dish" v-show="dish_show" :first_get_data="false"></monitor_big_dish>

    </el-dialog>


    <el-dialog


      :visible.sync="message_show"
      width="75%"

      title="发送消息记录"

    >

         <el-row style="padding-right: 10px">


          <el-table
            v-loading="message_table_loading"

            class="el-table-filter "
            highlight-current-row
            ref="message_Table"
            :data="message_Data"
            tooltip-effect="dark"
            stripe
            :header-row-style="header_row_style"
            :header-cell-style="header_cell_style"
            :row-style="row_style"
            :cell-style="cell_style"
            height="400px"
            size="mini"
            style="margin-left:10px;margin-right: 20px"



          >

            <el-table-column
              prop="send_time"
              label="发送时间"
              width="160"
              show-overflow-tooltip
              sortable>
            </el-table-column>
            <el-table-column
              prop="channel_name"
              label="通知方式"
              width="160"

              sortable>
              <template slot-scope="scope">
                <channel_type_show :channel_type="scope.row.channel_type"
                                   :name="scope.row.channel_name"></channel_type_show>
              </template>
            </el-table-column>

            <el-table-column
              prop="msg_content"
              label="消息内容"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                        <span :title=scope.row.msg_content
                              class="msg_content"
                              style="cursor: pointer">
                          {{scope.row.msg_content}}
                        </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="project_name"
              label="接受对象"
              width="130"
              show-overflow-tooltip
              sortable>
            </el-table-column>
            <el-table-column
              prop="send_statu"
              label="发送状态"
              align="center"
              width="90">


              <template slot-scope="scope">
                         <span v-if="scope.row.send_statu=='1'">
                              <i class="el-icon-circle-close" title="失败"
                                 style="color: #C15C17;font-size: 19px;font-weight: bold"></i>
                            </span>
                <span v-else>
                           <i class="el-icon-circle-check" title="正常"
                              style="color: #66CC00;font-size: 19px;font-weight: bold"></i>
                        </span>
              </template>
            </el-table-column>
          </el-table>
        </el-row>


    </el-dialog>


    <ai-analysis-dialog ref="aiAnalysisDialog"></ai-analysis-dialog>
  </el-row>
</template>

<script>
  import * as API from "@/api/index.js"
  import monitor_big_dish from "@/components/monitoring_center/monitor_big_dish/index"
  import channel_type_show from "@/components/common_page/channel_type_show"
  import AiAnalysisDialog from "@/components/common_page/AiAnalysisDialog"

  export default {
    props: ["zabbix_alarm_data"],
    watch: {
      zabbix_alarm_data: function (newVal, oldVal) {
        this.zabbix_alarm_data = newVal
      },
    },
    components: {
      channel_type_show,
      monitor_big_dish,
      AiAnalysisDialog
    },
    computed: {
      twinkle_computer: function () {

        return function (alert_time, is_confirm) {
          var end_time = this.$_get_local_data();
          end_time = end_time.replace(/-/g, "/");
          var current_date = new Date(end_time);
          if (alert_time != undefined) {
            alert_time = alert_time.toString()
            alert_time = alert_time.replace(/-/g, "/");
          }
          var start_data = new Date(alert_time)
          var existed = (current_date - start_data) / 1000;
          var secondTime = parseInt(existed);// 秒
          var return_ruset = ''
//           && is_confirm == '0'
          if (secondTime < this.com_time_int) {
            return_ruset = 'blink'
          } else {
            return_ruset = 'blinks'
          }
          return return_ruset
        }
      },
    },
    data() {
      return {
         message_Data: [],
        message_show:false,
        dish_show: false,
        heart: require("@/assets/heart.png"),
        disaster: require("@/assets/disaster.png"),
        heart_break: require("@/assets/heart_break.png"),
        message_button_dia: true,
        scan_add_loading: false,
        labelPosition: 'left',
        dialog_information_panel: false,
        dialog_warning_confirm: false,
        dialog_history_panel: false,
        dialog_inforlist_panel: false,
        //确认告警的数据
        confirm_alarm: {
          confirm_message: '',
          is_close: '0'
        },
        zabbix_alarm_tableData: [],
        //点击行数据
        click_warning: {},
        cart_body_style: {padding: '6px 6px', cursor: 'pointer'},
        //选中行的历史告警信息
        infor_list_tableData: [],
        com_time_int: '',
        secondTime: '',
        message_table_loading:false,
        alertitem_record_id:"",
      }
    },
    mounted() {
      let com_time = window.$config.twinkle_time
      this.com_time_int = parseInt(time_transform(com_time))
    },
    methods: {
       ai_analysis_button(item) {
          this.$refs.aiAnalysisDialog.open(item);
       },
       //获取消息队列数据
      async information_list_getData() {
        this.message_table_loading = true
        var datas = {'alertitem_record_id': this.alertitem_record_id, "project": this.project}
        const response = await API.GET('/omnis/monitoring_center/monitoring_real_time/message_log', datas)
        this.message_table_loading = false
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.message_Data = data.data
            this.message_count = data.count
            //       this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        } else {
          // this.$message.error('系统错误');
        }
      },
      card_click(item) {
        this.click_warning = item
        this.$emit("card_click", item)
      },
      big_panel_button(hostip, project) {

        this.dish_show = true
        this.$nextTick(() => {
          this.$refs.dish.open_server(hostip, project)
        })
      },
      //查看信息按钮
      infor_mon_button() {
        this.dialog_information_panel = true
        //       this.$emit("infor_mon_button")
      },
      infor_mon_button2(item) {
        this.click_warning = item
        this.dialog_information_panel = true
      },
      //进入确认告警信息的按钮
      confirm_warn_button() {
        this.dialog_warning_confirm = true
      },

      //确认告警按钮的点击事件
      confirm_alarm_button() {
        this.confirm_alarm_getData()

      },

      //
      async confirm_alarm_getData() {
        var data = JSON.parse(JSON.stringify(this.confirm_alarm))
        data.eventid = this.click_warning.event_id
        data.alertitem_record_id = this.click_warning.alertitem_record_id
        data.agent_id = this.click_warning.monitor_agent_id
        data.server_id = this.click_warning.server_id
        data.server_ip = this.click_warning.server_ip
        data.is_confirm = 1
        const response = await API.POST('/omnis/assets_operations/ops_console/zabbix_acknowledge', data)
        if (response && response.data) {
          var data = response.data
          if (data.success) {

            this.$message.success(data.msg);
            this.dialog_warning_confirm = false
            this.$emit("confirm")
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('系统错误');
        }
      },
      //历史信息查看
      history_list_button(item) {
        this.click_warning = item

        this.dialog_history_panel = true
        this.history_list_getData()
      },

      async history_list_getData() {
        var datas = {}
        datas.server_envs_id = ''
        datas.server_search = ''
        datas.alert_level = ''
        datas.alert_statu = ''
        datas.is_recover = ''
        datas.page = 1
        datas.size = 10000
        datas.server_id = this.click_warning.server_id
        datas.server_ip = this.click_warning.hostip
        this.infor_list_tableData = []
        this.scan_add_loading = true
        const response = await API.GET('/omnis/monitoring_center/monitoring_history/monitor_history', datas)
        this.scan_add_loading = false
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.infor_list_tableData = data.data
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('系统错误');
        }
      },

      //消息列队进行过滤查看
      information_list_button(item) {
        this.click_warning = item
        this.alertitem_record_id = item.alertitem_record_id
        this.project = item.project
        this.message_show = true
        this.information_list_getData()

      },


    },
  }
</script>

<style scoped>
  .text {
    font-size: 10px;
    color: #000000;
    font-weight: bold;
    margin-bottom: 7px;
  }

  .box-card {
    width: 99%;
    margin: 5px auto;
    background: #E1E7EF;
    border: none;
  }

  @keyframes blink {
    /*60%{opacity: 1;}*/
    /*50%{opacity: 1;}*/
    30.01% {
      opacity: 0.3;
    }
    /* 注意这里定义50.01%立刻透明度为０，可以设置闪烁效果 */
    100% {
      opacity: 0.9;
    }
  }

  /* 添加兼容性前缀 */

  /*@-webkit-keyframes blink {*/
  /*0% { opacity: 1; }*/
  /*50% { opacity: 1; }*/
  /*50.01% { opacity: 0; }*/
  /*100% { opacity: 0; }*/
  /*}*/

  /*@-moz-keyframes blink {*/
  /*0% { opacity: 1; }*/
  /*50% { opacity: 1; }*/
  /*50.01% { opacity: 0; }*/
  /*100% { opacity: 0; }*/
  /*}*/

  /*@-ms-keyframes blink {*/
  /*0% { opacity: 1; }*/
  /*50% { opacity: 1; }*/
  /*50.01% { opacity: 0; }*/
  /*100% { opacity: 0; }*/
  /*}*/

  /*@-o-keyframes blink {*/
  /*0% { opacity: 1; }*/
  /*50% { opacity: 1; }*/
  /*50.01% { opacity: 0; }*/
  /*100% { opacity: 0; }*/
  /*}*/

  /* 定义blink类*/
  .blink {
    animation: blink 2s linear infinite;
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: blink 2s linear infinite;
    -moz-animation: blink 2s linear infinite;
    -ms-animation: blink 2s linear infinite;
    -o-animation: blink 2s linear infinite;
    color: #dd4814;
  }

  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .icon_text {
    font-size: 19px;
    margin-top: 6px
  }

  #infor_div {
    max-height: 500px;
  }

  .warning_text {
    color: rgb(229, 172, 14);
  }

  .important_text {
    color: rgb(192, 92, 23);
  }

  .disaster_text {
    color: rgb(137, 15, 2);
  }

  .high_text {
    color: rgb(191, 27, 0)
  }

  .unknown_text {
    color: #b0b4cf
  }


  .remind_text {
    color: rgb(130, 181, 216);
  }

  .zabbix-trigger--blinked {
    opacity: 0.4;
    animation: zabbix-triggers-icon 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96) 0s infinite alternate;
  }

  .problem_text {
    font-family: Roboto, Helvetica Neue, Arial, sans-serif;
    color: #c4162a;
    font-weight: bolder;
    font-size: 64%;
  }

  .alert-rule-item__text span {
    padding-right: 0.4em;
  }

  .zbx-trigger-card {
    position: relative;
    padding: 0.1rem 0rem;
  }

  .alert-rule-item {
    width: 100%;
    height: 100%;
    background: -webkit-linear-gradient(315deg, #e9edf2, #dde4ed);
    background: -o-linear-gradient(315deg, #e9edf2, #dde4ed);
    background: linear-gradient(135deg, #e9edf2, #dde4ed);

    box-sizing: inherit;
    border-radius: 4px;
    margin-bottom: 4px;
  }


  .alert-rule-item:hover {

    background: -webkit-linear-gradient(315deg, #d8e9edf2, #d8dde4ed);
    background: -o-linear-gradient(315deg, #d8e9edf2, #d8dde4ed);
    background: linear-gradient(135deg, #d8e9edf2, #d8dde4ed);


  }


  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: -1px -1px 0 0 hsla(0, 0%, 100%, .1), 1px 1px 0 0 rgba(0, 0, 0, .1) !important;
    box-shadow: -1px -1px 0 0 hsla(0, 0%, 100%, .1), 1px 1px 0 0 rgba(0, 0, 0, .1) !important;
  }

  .important_img {
    width: 24px;
    transform: translateX(-1px)
  }

  .heart_break_img {
    width: 15px;
    margin-left: 2px;
    transform: translateY(5px) translateX(2px);

  }

  .disaster_img {
    width: 22px;
    transform: translateX(-2px);
  }


  .button_text {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: 16px;
    text-rendering: auto;
    margin-right: 5px;

    -webkit-font-smoothing: antialiased;
  }

  .import-color-background {
    background: #FFCD0044;
  }


  .danger-color-background {
    background: #FFCD00;
  }

  .disaster-color-background {
    background: #FF9900;
  }

  .text_title {
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    display: inline-block;
  }

  .msg_content {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    display: inline-block;
    transform: translateY(2px) !important;
  }


</style>



// WEBPACK FOOTER //
// monitoring_grafana.vue?e7e9a33a